import { getFileNameWithoutExtension } from 'utils';

export function compareFileNames(
  fileName1: string,
  fileName2: string,
): boolean {
  return (
    getFileNameWithoutExtension(fileName1) ===
    getFileNameWithoutExtension(fileName2)
  );
}
